import { createReducer, ActionType } from "typesafe-actions";
import { Auth } from "types";
import * as actions from "./actions";

type AuthActions = ActionType<typeof actions>;

const initialState: Auth = {
  data: {} as any,
  isLoggedIn: false,
  isAuthenticating: true,
};

const reducer = createReducer<Auth, AuthActions>(initialState)
  .handleAction(actions.setAuth, (state, { payload: newAuth }) => ({
    ...state,
    ...newAuth,
  }))
  .handleAction(
    actions.setAccessibilitySettings,
    (state, { payload: newAcc }) => ({
      ...state,
      data: {
        ...state.data,
        user: {
          ...state.data.user,
          ...newAcc,
        },
      },
    }),
  );

export default reducer;
